export default __webpack_public_path__ + "static/media/Marketing-Illustration.b0bf1903.png";